export function cancellationPolicyText(quote) {
  if (quote?.tier === "full") return "Full refund — your full funded value will be returned.";
  if (quote?.tier === "maximum") {
    return "Maximum refund — taxes are returned, less the platform retention and any secured Airalo SIM cost.";
  }
  if (quote?.tier === "partial") {
    return "Partial refund — 50% of base rental, plus taxes and any one-way or after-hours fees. Platform fees and coupons are not refunded.";
  }
  if (quote?.tier === "none") {
    return "Non-refundable — cancelled less than 6 hours before pick-up. No refund applies.";
  }
  return "";
}

export function partnerCancellationHint(booking) {
  if (!booking?.external_partner) return "";
  const partner = booking.external_partner;
  return `Partner reservation via ${partner}. Your Z-Cars refund follows our standard tiers; we notify the partner to cancel with their supplier.`;
}

export function cancellationError(detail, action = "quote") {
  if (detail === "cancellation_quote_expired" || detail === "cancellation_quote_changed") {
    return "The refund changed while this dialog was open. Review the refreshed amount before confirming.";
  }
  if (detail === "active_trip_requires_support") return "Active trips must be ended through support.";
  if (detail === "admin_cancellation_reason_required") {
    return "Add a short reason before confirming this admin cancellation.";
  }
  if (detail === "cancellation_refund_failed_retryable") {
    return "The payment refund could not be started. Your booking was not cancelled. Please try again.";
  }
  if (detail === "cancellation_processing_failed_retryable") {
    return "Cancellation could not be completed safely. Your booking is recoverable; please try again.";
  }
  if (typeof detail === "string") return detail.replaceAll("_", " ");
  return action === "confirm"
    ? "Unable to complete the cancellation. Your booking has not been confirmed as cancelled."
    : "Unable to calculate the refund.";
}

export function adminCancellationRequiresReason(quote) {
  return quote?.actor === "admin";
}
